// 重构的state
export default {
  // 品类list
  categoryList: [],
  // 销售姓名面包屑
  breadCrumbList: [],
  // 销售姓名列表数据
  salesNameData: {},
  // 商机详情，以id为key
  details: {},
  // 诊断数据
  diagnosis: {},
  storeInfo: {
    priorityStore: {
      listData: [],
      pageNo: 1,
      total: 0
    },
    areaStore: {
      listData: [],
      pageNo: 1,
      total: 0
    },
    myStore: {
      listData: [],
      pageNo: 1,
      total: 0
    },
    allStore: {
      listData: [],
      pageNo: 1,
      total: 0
    }
  },
  // 业务策略标签在首页和门店列表都有用到
  // 销售姓名选中数量
  salesNameNum: 0,
  strategyTagData: [],
  commonCityData: [],
  // 门店筛选项 已选中条件的数量
  selectNumstatus: '', // 签约状态
  selectNumcombine: '', // 门店价值
  selectNumother: '', // 其他筛选项
  isFromGiveUp: false, // 用于详情页面判断是否重新刷新数据
  currentTab: 'priorityStore', // 当前选中的值
  cityIdsWithAuth: { cityId: '' }, // 根据经纬度获取有权限的城市数据
  commnoCityAreaTree: [], // 通用三个tab城市商圈的数据
  areaCityAreaTree: [], // 商圈tab下城市商圈的数据
  commonFilter: {},
  // 这里是合并了左侧集合筛选、城市筛选、排序、标签、销售姓名选中数据
  allFilterParams: {
    sortType: 0,
    notMyStore: false,
    // 诊断分数
    diagnosisScoreStart: 0,
    diagnosisScoreEnd: 100,
    diagnosisScoreFlag: 0,
    status: []
  },

  areaChecked: [], // 商圈选中的数据
  commonAreaChecked: [], // 其他3个tab的选中商圈的数据
  commonCityChecked: '', // 通用三个tab选中的城市
  areaCityChecked: '', // 商圈选中的城市
  // 筛选取消标记
  commonFilterCancelTag: 0,
  // 判断策略标签是否从首页进入
  strategyTagFromWorkbench: false,

  changeHistory: {} // 搜索历史 type 1 sug推荐 2 搜索结果
}
